import React from 'react';
import { Helmet } from 'react-helmet';
import Hero from './Home/Hero';
import Slideshow from './Home/Slideshow';
import Features from './Home/Features';
import Testimonials from './Home/Testimonials';
import NewsletterSignup from './Home/NewsletterSignup';

const HomePage = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--background-color)' }}>
       <Helmet>
        <title>Home | Amaze Puzzles</title>
        <meta
          name="description"
          content="Discover the Braille Skills Puzzle — a modern, play-based tool designed to enhance Braille literacy."
        />
      </Helmet>
      <Hero />
      <Slideshow />
      <Features />

      {/* New testimonials section */}
      <Testimonials />

      <NewsletterSignup />
    </div>
  );
};

export default HomePage;
